import React from "react"

import {
  UseProfileDeleteOverlayViewModelProps,
  useProfileDeleteOverlayViewModel
} from "./model/useProfileDeleteOverlayViewModel"
import { ProfileDeleteOverlayView } from "./ui/ProfileDeleteOverlayView"

export const ProfileDeleteOverlay = React.memo(
  (props: UseProfileDeleteOverlayViewModelProps) => {
    return (
      <ProfileDeleteOverlayView {...useProfileDeleteOverlayViewModel(props)} />
    )
  }
)
